import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'home-broadcast-widget.common.flags.title',
		defaultMessage: "We couldn't dismiss the recommendation",
		description:
			'Title of the flag shown in Jira home page when the request for dismissing broadcast widget failed',
	},
	description: {
		id: 'home-broadcast-widget.common.flags.description',
		defaultMessage: 'Refresh your page and try again.',
		description:
			'Description of the flag shown in Jira home page when the request for dismissing broadcast widget failed',
	},
});
